<h3 style="text-align: center;">{{ selectedCategory ? selectedCategory.label : (searchTerm ? 'Recherche : ' + searchTerm : '') }}</h3>

<div style="display: flex; align-items: center; gap: 16px; flex-wrap: wrap; margin-bottom: 8px;">
  <mat-form-field appearance="fill" style="margin-bottom: -1.25em;">
    <mat-label>Choix catégorie</mat-label>
    <mat-select [value]="selectedCategory" (selectionChange)="onCategoryChange($event.value)">
      <mat-option [value]="null">—</mat-option>
      <mat-option *ngFor="let cat of categories" [value]="cat">
        {{ cat.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" style="margin-bottom: -1.25em;">
    <mat-label>Recherche artiste / titre</mat-label>
    <input matInput [(ngModel)]="searchTerm" (keydown.enter)="onSearch()" placeholder="Min. 2 caractères">
  </mat-form-field>
  <button mat-flat-button color="primary" (click)="onSearch()" [disabled]="searchTerm.trim().length < 2 || loading">
    Rechercher
  </button>
</div>

<table style="width: 100%" mat-table [dataSource]="mediasMatTable" matSort matSortActive="modify" matSortDirection="desc">

  <ng-container matColumnDef="player">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell style="padding-right: 20px" *matCellDef="let element">
      <mat-icon *ngIf="extraitLocation + element.id + '.mp3' !== editService.audioPlaying" (click)="editService.playextrait(extraitLocation + element.id + '.mp3')"
                style="cursor: pointer; vertical-align: bottom;" svgIcon="play"></mat-icon>
      <mat-icon *ngIf="extraitLocation + element.id + '.mp3' === editService.audioPlaying" (click)="editService.stopextrait()"
                style="cursor: pointer; vertical-align: bottom;" svgIcon="stop"></mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="imedia">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> IMedia </th>
    <td mat-cell style="padding-right: 40px" *matCellDef="let element"> {{ element.imedia }} </td>
  </ng-container>

  <ng-container matColumnDef="performer">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Artiste </th>
    <td mat-cell *matCellDef="let element"> {{ element.performer }} </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Titre </th>
    <td mat-cell *matCellDef="let element"> {{ element.title }} </td>
  </ng-container>

  <ng-container matColumnDef="version">
    <th mat-header-cell *matHeaderCellDef> Version </th>
    <td mat-cell *matCellDef="let element"> {{ element.version }} </td>
  </ng-container>

  <ng-container matColumnDef="proprietes">
    <th mat-header-cell style="font-weight: bold;" *matHeaderCellDef> Proprietes </th>
    <td mat-cell *matCellDef="let element" style="font-weight: bold;"> {{ element.proprietes }} </td>
  </ng-container>

  <ng-container matColumnDef="mood3">
    <th mat-header-cell style="font-weight: bold;" *matHeaderCellDef> Mood 3 </th>
    <td mat-cell *matCellDef="let element" style="font-weight: bold;"> {{ element.mood3 }} </td>
  </ng-container>

  <ng-container matColumnDef="modify">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Import </th>
    <td mat-cell *matCellDef="let element"> {{ element.modify | date:'dd/MM/yyyy HH:mm' }} </td>
  </ng-container>

  <ng-container matColumnDef="edit">
    <th mat-header-cell *matHeaderCellDef> Edit </th>
    <td mat-cell *matCellDef="let element">
      <button color="primary" style="min-width: 48px; padding: 0 8px; margin-right: 8px;" (click)="editDialog(element)" mat-flat-button>
        <mat-icon svgIcon="edit" style="margin: auto;"></mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div *ngIf="loading" class="edit-spinner-container">
  <mat-progress-spinner class="mat-progress-spinner-editwin" mode="indeterminate"></mat-progress-spinner>
</div>

<mat-paginator #Paginator [length]="medias.length"
               [pageSize]="100" [pageSizeOptions]="[100, 200, 500]" showFirstLastButtons></mat-paginator>
